// Хук: показать toast "API недоступен" один раз при первой ошибке useQuery,
// и вернуть либо data, либо mock-fallback.

import { useEffect, useRef } from "react";
import { useToast } from "../components/Toast";

export function useApiFallback<T>(
  data: T | undefined,
  isError: boolean,
  fallback: T,
): { value: T; usingFallback: boolean } {
  const push = useToast();
  const warnedRef = useRef(false);

  useEffect(() => {
    if (isError && !warnedRef.current) {
      warnedRef.current = true;
      push({ kind: "warn", text: "API недоступен — показаны демо-данные" });
    }
    if (!isError) warnedRef.current = false;
  }, [isError, push]);

  if (data !== undefined && !isError) return { value: data, usingFallback: false };
  if (isError) return { value: fallback, usingFallback: true };
  // ещё грузится — НЕ показываем mock-fallback (это вызывает «мерцание» демо-данными
  // при reload, что вводит пользователя в заблуждение). Возвращаем fallback только
  // если он реально нужен (после явной ошибки), а пока loading — пустоту/undefined-like.
  return { value: data ?? fallback, usingFallback: false };
}
